const request = {
    invalid_input: 'الإدخال غير صالح. {{details}}',
    general: 'حدث خطأ في الطلب.',
    /** UNTRANSLATED */
    range_not_satisfiable: 'Range not satisfiable.',
};
export default Object.freeze(request);
